module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_engl_primærlogo_sentrert_logo_pos.35b87c97.svg";